var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "" },
      model: {
        value: _vm.DispositivosTotalesPorTecnico,
        callback: function($$v) {
          _vm.DispositivosTotalesPorTecnico = $$v
        },
        expression: "DispositivosTotalesPorTecnico"
      }
    },
    [
      _c("v-container", { attrs: { fluid: "", white: "" } }, [
        _c(
          "div",
          {},
          [
            _c(
              "v-layout",
              { attrs: { row: "", wrap: "" } },
              [
                _c(
                  "v-flex",
                  { attrs: { xs4: "", sm4: "", md4: "" } },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Buscar", outlined: "" },
                      on: {
                        keyup: function($event) {
                          return _vm.gridApi.setQuickFilter(_vm.filtro)
                        }
                      },
                      model: {
                        value: _vm.filtro,
                        callback: function($$v) {
                          _vm.filtro = $$v
                        },
                        expression: "filtro"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "gridcard rounded-card" },
              [
                _c("AgGridVue", {
                  staticClass: "ag-theme-material",
                  staticStyle: { "font-family": "'Asap', sans-serif" },
                  attrs: { gridOptions: _vm.gridOptions }
                })
              ],
              1
            ),
            _c(
              "v-layout",
              { staticClass: "mt-3", attrs: { row: "", wrap: "" } },
              [
                _c("v-flex", { attrs: { xs8: "", sm8: "", md9: "" } }),
                _c(
                  "v-flex",
                  {
                    staticStyle: { "text-align": "end" },
                    attrs: { xs4: "", sm4: "", md3: "" }
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "btn-volver white--text",
                        on: {
                          click: function($event) {
                            return _vm.cerrarModal()
                          }
                        }
                      },
                      [_vm._v("Cancelar")]
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "btn-grabar white--text",
                        on: {
                          click: function($event) {
                            return _vm.guardar()
                          }
                        }
                      },
                      [_vm._v("Guardar")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }